const setAppReady = () => {
  if (window.Cypress) {
    window.appReady = true;
  }
};

export { setAppReady };
